import {render, fireEvent} from '@testing-library/react/pure';
import PdpTextField from '.';

describe('PdpTextField', () => {
  test('calls the onHandleChange function when input value changes', () => {
    const handleChangeMock = jest.fn();
    const {getByTestId} = render(
      <PdpTextField inputDefaultedValue="10" onHandleChange={handleChangeMock} />
    );
    const inputField = getByTestId('quote-input');

    fireEvent.change(inputField, {target: {value: '20'}});

    expect(handleChangeMock).toHaveBeenCalledTimes(1);
    expect(handleChangeMock).toHaveBeenCalledWith('20');
  });
});
